var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnrgyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2446 35.6707C16.0124 35.9029 15.7354 36.0123 15.4134 35.9989C15.0904 35.9865 14.8128 35.8642 14.5806 35.632C14.3742 35.4256 14.2581 35.1676 14.2323 34.858C14.2065 34.5485 14.2839 34.2776 14.4645 34.0454L21.9721 23.5966L9.43361 22.3969C8.76282 22.3454 8.31752 21.9971 8.09771 21.3521C7.87893 20.7071 8.02754 20.1653 8.54353 19.7267L24.6036 5.33066C24.8358 5.09846 25.1134 4.98856 25.4364 5.00094C25.7584 5.01436 26.0355 5.13716 26.2677 5.36936C26.4741 5.57575 26.5902 5.83374 26.616 6.14334C26.6418 6.45293 26.5644 6.72382 26.3838 6.95602L18.8762 17.4048L31.4147 18.6044C32.0855 18.656 32.5302 19.0043 32.749 19.6493C32.9688 20.2943 32.8207 20.8361 32.3048 21.2747L16.2446 35.6707Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2446 35.6707C16.0124 35.9029 15.7354 36.0123 15.4134 35.9989C15.0904 35.9865 14.8128 35.8642 14.5806 35.632C14.3742 35.4256 14.2581 35.1676 14.2323 34.858C14.2065 34.5485 14.2839 34.2776 14.4645 34.0454L21.9721 23.5966L9.43361 22.3969C8.76282 22.3454 8.31752 21.9971 8.09771 21.3521C7.87893 20.7071 8.02754 20.1653 8.54353 19.7267L24.6036 5.33066C24.8358 5.09846 25.1134 4.98856 25.4364 5.00094C25.7584 5.01436 26.0355 5.13716 26.2677 5.36936C26.4741 5.57575 26.5902 5.83374 26.616 6.14334C26.6418 6.45293 26.5644 6.72382 26.3838 6.95602L18.8762 17.4048L31.4147 18.6044C32.0855 18.656 32.5302 19.0043 32.749 19.6493C32.9688 20.2943 32.8207 20.8361 32.3048 21.2747L16.2446 35.6707Z",
    fill: "url(#paint0_linear_1125_1042)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_1042",
    x1: 20.4238,
    y1: 5,
    x2: 20.4238,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrgyIcon);
export default __webpack_public_path__ + "static/media/enrgyIcon.9adfb62378f08475491b92bf6c9514f0.svg";
export { ForwardRef as ReactComponent };